<template>
  <div class="faq-page">
    <bert-loading 
      v-if="isLoading" 
      :fullscreen="true" 
      size="lg" 
      text="Loading FAQ..."
    />

    <div v-else class="page-content">
      <AppHeader />

      <section class="faq-section">
        <div class="section-container">
          <div class="faq-header">
            <div class="faq-icon" @click="goBack">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
                <circle cx="20" cy="20" r="20" fill="var(--yellow-main)"/>
                <path d="M24 12L16 20L24 28" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h1 class="faq-title">FAQ</h1>
          </div>
          
          <div class="faq-list">
            <div 
              v-for="faq in faqs" 
              :key="faq.id"
              class="faq-item"
              :class="{ active: faq.isOpen }"
            >
              <div class="faq-question" @click="toggleFaq(faq.id)">
                <h3>{{ faq.question }}</h3>
                <div class="faq-toggle" :class="{ active: faq.isOpen }">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <circle cx="12" cy="12" r="12" fill="var(--yellow-main)"/>
                    <path d="M8 12h8M12 8v8" stroke="white" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                </div>
              </div>
              <div class="faq-answer" :class="{ open: faq.isOpen }" ref="faqAnswer">
                <div class="faq-answer-content" ref="faqContent">
                  <div class="formatted-text" v-html="faq.answer"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AppFooter />
    </div>
  </div>
</template>

<script>
import BertLoading from './ui/Loading.vue'
import Header from './layout/Header.vue'
import Footer from './layout/Footer.vue'

export default {
  name: 'FAQ',
  components: {
    BertLoading,
    AppHeader: Header,
    AppFooter: Footer
  },
  data() {
    return {
      isLoading: false,
      faqs: [
        {
          id: 1,
          question: 'Apa itu Bert Points?',
          answer: 'Bert Points adalah Program Rewards yang dibuat untuk Member & Influencer BERT\'s Community (Ibu2Canggih, Geng Glowing, dan Ikan Galau). Secara sederhana, Bert Points adalah program mengumpulkan point yang diperoleh dengan cara mengikuti berbagai kegiatan komunitas.',
          isOpen: true
        },
        {
          id: 2,
          question: 'Komunitas apa yang sebaiknya saya pilih saat mendaftar?',
          answer: 'Silakan memilih komunitas sesuai WhatsApp Group (WAG) yang Anda ikuti. Jika Anda merupakan member WAG BERT\'s Community (Ibu2Canggih, Geng Glowing, atau Ikan Galau) Anda bisa langsung memilih salah satu komunitas tersebut. Namun, jika Anda adalah Influencer dari BERT\'s Community (Momfluencer, Glowfluencer, Creator) silakan mendaftar sebagai BERT\'s Influencer.',
          isOpen: false
        },
        {
          id: 3,
          question: 'Saya bukan member BERT\'s community, dan bukan BERT\'s Influencer. Bolehkah saya bergabung, dan bagaimana caranya?',
          answer: 'Anda bisa bergabung terlebih dahulu ke WhatsApp Group (WAG) komunitas yang Anda minati melalui link pada bio Instagram Ibu2Canggih, Geng Glowing, atau Ikan Galau. Setelah menjadi anggota WAG, silakan registrasi melalui bertpoints.com.',
          isOpen: false
        },
        {
          id: 4,
          question: 'Apakah saya harus membayar untuk mengumpulkan Bert Points?',
          answer: 'Tidak. Program ini GRATIS dan tidak dipungut biaya apapun.',
          isOpen: false
        },
        {
          id: 5,
          question: 'Apa saja jenis-jenis Bert Points?',
          answer: 'Bert Points terdiri dari 2 jenis Points, yaitu Reward Points & Award Points.',
          isOpen: false
        },
        {
          id: 6,
          question: 'Apa perbedaan Reward Points dan Award Points?',
          // UPDATED: Added <br> tags for spacing
          answer: `Reward Points adalah Points yang didapat jika mendaftar di bertpoints.com sebagai member salah satu BERT's Community, yaitu Ibu2Canggih, Geng Glowing, dan Ikan Galau. Reward Points ini diperoleh dengan cara mengikuti kegiatan seperti menyukai komentar di media sosial, mengikuti Kuliah WhatsApp, menonton IG Live, Webinar dan kegiatan lainnya. Reward Points yang terkumpul bisa dipergunakan untuk Klaim Hadiah dari beragam brands di website ini.
          <br><br>
          Award Points adalah Points yang didapatkan jika mendaftar di bertpoints.com sebagai BERT's Influencer. Award Points ini diperoleh dengan cara mengikuti kegiatan seperti Product Review, Event Visit, Host, Challenge, dan kegiatan lainnya. Influencer terpilih di setiap bulan akan mendapatkan gelar Pointers of the Month dan mendapatkan hadiah eksklusif dari BERT's. 
          <br><br>
          Segala informasi terkait kegiatan yang memiliki benefit Reward dan Award Points akan di-share di WAG setiap komunitas.`,
          isOpen: false
        },
        {
          id: 7,
          question: 'Bagaimana caranya menjadi Pointers of the Month?',
          answer: 'Reward Points akan di-reset tiap 3 bulan sekali, dan Points akan hangus jika tidak digunakan untuk Klaim Hadiah.',
          isOpen: false
        },
        {
          id: 8,
          question: 'Bagaimana caranya Klaim Hadiah?',
          answer: 'Untuk menjadi Pointers of the Month, pastikan Anda selalu Klaim Point di website setelah Project selesai agar Points masuk ke dalam akun. Pointers of the Month nantinya akan mendapatkan hadiah eksklusif dari BERT’s.',
          isOpen: false
        },
        {
          id: 9,
          question: 'Kapan saya bisa Klaim Hadiah untuk Reward Points?',
          answer: 'Masuk ke menu Points, dan lihat jumlah Points yang sudah Anda peroleh. Pilih hadiah yang ingin Anda klaim sesuai jumlah Points & jangan lupa lihat stock barangnya. Info terkait Resi & Brief Product akan diinfokan oleh Admin kami melalui WhatsApp.',
          isOpen: false
        },
        {
          id: 10,
          question: 'Kapan saya bisa Klaim Hadiah untuk Reward Points?',
          // UPDATED: Added HTML for ordered list and bold text
          answer: `Anda bisa melakukan Klaim Hadiah di bertpoints.com satu kali setiap minggu, yaitu di hari Kamis atau Jumat. Admin kami akan mengumumkan jadwal Klaim Hadiah setiap Kamis pagi di seluruh WAG community. Pengiriman Hadiah yang sudah diklaim akan dilakukan 2 minggu sekali. 
          <br><br>
          <b>Contoh:</b>
          <ol>
            <li>Hadiah yang diklaim pada minggu pertama dan kedua Juli akan dikirim pada Jumat minggu ketiga Juli.</li>
            <li>Hadiah yang diklaim pada minggu ketiga dan keempat Juli akan dikirim pada Jumat minggu kelima Juli, atau Jumat minggu pertama Agustus.</li>
          </ol>`,
          isOpen: false
        }
      ]
    }
  },
  methods: {
    toggleFaq(id) {
      const faq = this.faqs.find(f => f.id === id)
      if (faq) {
        faq.isOpen = !faq.isOpen
      }
    },
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1)
      } else {
        this.$router.push('/')
      }
    },
    loading() {
      this.isLoading = true
      setTimeout(() => {
        this.isLoading = false
      }, 1000)
    }
  },
  mounted() {
    this.loading()
  }
}
</script>

<style scoped>
.faq-page {
  min-height: 100vh;
  background: #F5F5F5;
}

.page-content {
  width: 100%;
}

/* FAQ Section */
.faq-section {
  padding: var(--space-20) 0;
  background: white;
}

.section-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 0 var(--space-6);
}

.faq-header {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  margin-bottom: var(--space-12);
}

.faq-icon {
  flex-shrink: 0;
  cursor: pointer;
  transition: all var(--transition-base);
}

.faq-icon:hover {
  transform: scale(1.05);
  opacity: 0.8;
}

.faq-title {
  font-size: var(--text-4xl);
  font-weight: var(--font-bold);
  color: var(--text-dark);
  margin: 0;
}

.faq-list {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.faq-item {
  background: white;
  border: 1px solid var(--neutral-200);
  border-radius: var(--radius-lg);
  overflow: hidden;
  transition: all var(--transition-base);
}

.faq-item:hover {
  box-shadow: var(--shadow-sm);
}

.faq-item.active {
  border-color: var(--yellow-main);
}

.faq-question {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-6);
  cursor: pointer;
  transition: background-color var(--transition-base);
}

.faq-question h3 {
  font-size: var(--text-lg);
  font-weight: var(--font-medium);
  color: var(--text-dark);
  margin: 0;
  line-height: 1.4;
  flex: 1;
  padding-right: var(--space-4);
}

.faq-toggle {
  flex-shrink: 0;
  transition: transform 0.3s ease-out;
}

.faq-toggle.active {
  transform: rotate(45deg);
}

.faq-answer {
  display: grid;
  grid-template-rows: 0fr;
  transition: grid-template-rows 0.3s ease-out;
}

.faq-answer.open {
  grid-template-rows: 1fr;
}

.faq-answer-content {
  overflow: hidden;
  padding: 0 var(--space-6);
  transition: padding 0.3s ease-out;
}

.faq-answer.open .faq-answer-content {
  padding: 0 var(--space-6) var(--space-6) var(--space-6);
}

/* --- UPDATED FORMATTED TEXT STYLES --- */
.formatted-text {
  color: var(--text-dark-grey);
  line-height: 1.6;
  font-size: var(--text-base);
  padding-bottom: 2px;
}

/* Deep selector (>>>) is used to style v-html content inside scoped styles */
.formatted-text >>> b,
.formatted-text >>> strong {
  font-weight: 700;
  color: var(--text-dark);
}

.formatted-text >>> ol, 
.formatted-text >>> ul {
  margin: 8px 0;
  padding-left: 24px; /* Creates the indentation for numbers */
}

.formatted-text >>> li {
  margin-bottom: 6px;
  padding-left: 4px;
}

.formatted-text >>> br {
  display: block;
  margin-bottom: 4px;
  content: "";
}

/* Responsive Design */
@media (max-width: 768px) {
  .section-container {
    padding: 0 var(--space-4);
    max-width: 100%;
  }
  
  .faq-header {
    margin-bottom: var(--space-8);
    gap: var(--space-3);
  }
  
  .faq-title {
    font-size: var(--text-2xl);
  }
  
  .faq-list {
    gap: var(--space-3);
  }
  
  .faq-item {
    border-radius: var(--radius-md);
  }
  
  .faq-question {
    padding: var(--space-4);
    gap: var(--space-3);
  }
  
  .faq-question h3 {
    font-size: var(--text-base);
    line-height: 1.4;
  }
  
  .faq-answer-content {
    padding: 0 var(--space-4);
  }
  
  .faq-answer.open .faq-answer-content {
    padding: 0 var(--space-4) var(--space-4) var(--space-4);
  }
  
  .formatted-text {
    font-size: var(--text-sm);
    line-height: 1.5;
  }
}
</style>